import React from 'react';
import classNames from 'classnames';

import css from './IconCraftFair.module.css';

export const IconCraftFair = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        enableBackground: 'new 0 0 64 64',
      }}
      viewBox="0 0 64 64"
    >
      <path d="m61.447 6.105-8-4A1.002 1.002 0 0 0 53 2H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h50c.155 0 .309-.036.447-.105l8-4a1.001 1.001 0 0 0 0-1.79zM15 4h37v6H15V4zm-2 6h-2V4h2v6zM4 4h5v6H4V4zm50 5.382V4.618L58.764 7 54 9.382zM20 49.229V55.5c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5v-1c0-3.584-2.916-6.5-6.5-6.5h-4.874l-2.035-4.197a17.435 17.435 0 0 0 13.147-10.322 17.53 17.53 0 0 0 .89-11.094l-1.658-6.63a1.002 1.002 0 0 0-.867-.753 1.016 1.016 0 0 0-1.003.559L18 40.52 5.9 15.563a1.014 1.014 0 0 0-1.003-.559 1.002 1.002 0 0 0-.867.753l-1.658 6.63a17.531 17.531 0 0 0 .89 11.094 17.432 17.432 0 0 0 13.146 10.322L14.374 48H9.5A6.508 6.508 0 0 0 3 54.5v1C3 59.084 5.916 62 9.5 62s6.5-2.916 6.5-6.5v-6.271l2-4.125 2 4.125zM22 50h4.5c2.481 0 4.5 2.019 4.5 4.5v1c0 2.481-2.019 4.5-4.5 4.5S22 57.981 22 55.5V50zm8.698-31.085.989 3.957a15.532 15.532 0 0 1-.787 9.822 15.437 15.437 0 0 1-11.284 9.077l11.082-22.856zM5.1 32.694a15.525 15.525 0 0 1-.787-9.822l.989-3.957 11.082 22.856A15.433 15.433 0 0 1 5.1 32.694zM14 55.5c0 2.481-2.019 4.5-4.5 4.5S5 57.981 5 55.5v-1C5 52.019 7.019 50 9.5 50H14v5.5zM55 33v-6a1 1 0 0 0-1-1h-1v-4a.97.97 0 0 0-.039-.274l-2-7A.999.999 0 0 0 50 14h-2a.999.999 0 0 0-.961.726l-2 7A.97.97 0 0 0 45 22v4h-1a1 1 0 0 0-1 1v6c-3.86 0-7 3.141-7 7v21a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V40c0-3.859-3.14-7-7-7zm-8-10.86L48.754 16h.491L51 22.14V26h-4v-3.86zM45 28h8v5h-8v-5zm15 32H38V40c0-2.757 2.243-5 5-5h12c2.757 0 5 2.243 5 5v20z" />
    </svg>
  );
};

export default IconCraftFair;
